import { render, staticRenderFns } from "./RoleUser.vue?vue&type=template&id=cbf39dc8&scoped=true"
import script from "./RoleUser.vue?vue&type=script&lang=js"
export * from "./RoleUser.vue?vue&type=script&lang=js"
import style0 from "./RoleUser.vue?vue&type=style&index=0&id=cbf39dc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf39dc8",
  null
  
)

export default component.exports